import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import SeoSalaryCalculator from '../components/SeoSalaryCalculator';
import { extractSalaryFromUrl, isValidSalaryRoute } from '../utils/salaryRoutes';

const SalarySpecificPage = () => {
  const { salaryAmount } = useParams();
  
  // Validate the URL format and extract salary
  if (!isValidSalaryRoute(salaryAmount)) {
    return <Navigate to="/salary-calculator" replace />;
  }
  
  const salary = extractSalaryFromUrl(salaryAmount);

  return <SeoSalaryCalculator salary={salary} />;
};

export default SalarySpecificPage;